import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useIdHotelOwner } from '../../../../../contexts/HotelOwnerContext';
import CompetitorsNew from './CompetitorsNew';
import CompetitorsHistory from './CompetitorsHistory';

const CompetitorsSectionContent = () => {
    const { isLoading } = useZitoneoHotelPresentation();
    const translate = useTranslate();
    const [selectedTab, setSelectedTab] = useState<'new' | 'history'>('new');

    return (
        <div className='hotel-presentation__section' id='hotel-competitors'>
            {isLoading ? (
                <LoadingPlaceholder
                    variant='text'
                    width={150}
                    height={24}
                    aria-hidden='true'
                />
            ) : (
                <h2 className='hotel-presentation__section-title'>
                    {translate('competitor_analysis')}
                </h2>
            )}
            <div
                className='hotel-presentation__section-content'
                aria-busy={isLoading}
            >
                <Tabs
                    value={selectedTab}
                    onChange={(
                        _: React.SyntheticEvent,
                        value: 'new' | 'history'
                    ) => setSelectedTab(value)}
                    className='border-color-bottom'
                >
                    <Tab
                        id='competitors-new-tab'
                        aria-controls='competitors-new-panel'
                        value='new'
                        label={translate('new_analysis')}
                    />
                    <Tab
                        id='competitors-history-tab'
                        aria-controls='competitors-history-panel'
                        value='history'
                        label={translate('history')}
                    />
                </Tabs>
                {selectedTab === 'new' ? (
                    <CompetitorsNew />
                ) : (
                    <CompetitorsHistory />
                )}
            </div>
        </div>
    );
};

const CompetitorsSection = () => {
    const { hotel } = useZitoneoHotelPresentation();
    const ownerId = useIdHotelOwner();

    return (
        <CompetitorsSectionContent
            key={JSON.stringify([ownerId, hotel.id, hotel.idHotel])}
        />
    );
};

export default CompetitorsSection;
